document.querySelectorAll('.accordion-header').forEach(item => {
  item.addEventListener('click', () => {
    const content = item.nextElementSibling;
    const allContent = document.querySelectorAll('.accordion-content');
    
    allContent.forEach(el => {
      if (el !== content) el.style.display = 'none';
    });
    
    content.style.display = content.style.display === 'block' ? 'none' : 'block';
  });
});
